/**
 * Phase G+ Feb 2026 — Berichte vorübergehend leer.
 * Auf User-Anweisung: nur Platzhalter, konkrete Berichte folgen später.
 */
import { FileBarChart } from "lucide-react";

export default function Reports() {
  return (
    <div className="space-y-4" data-testid="reports-page">
      <div>
        <h1 className="font-display text-2xl font-bold text-zinc-50">Berichte</h1>
        <p className="text-sm text-zinc-400 mt-1">
          Auswertungen und Berichte werden hier erscheinen.
        </p>
      </div>

      <div
        className="rounded-lg border border-zinc-800 bg-zinc-950 p-10 text-center"
        data-testid="reports-placeholder"
      >
        <div className="mx-auto w-12 h-12 rounded-full bg-zinc-900 flex items-center justify-center">
          <FileBarChart className="w-6 h-6 text-zinc-500" />
        </div>
        <h2 className="mt-4 font-display text-lg font-semibold text-zinc-100">
          Noch keine Berichte vorhanden
        </h2>
        <p className="mt-2 text-sm text-zinc-400 max-w-md mx-auto">
          Sobald die ersten Berichte fertig sind, kannst du sie hier
          herunterladen und filtern.
        </p>
      </div>
    </div>
  );
}
